function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M270.948 7.472C136.116 18.837 65.315 104.074 47.224 138.168c42.89-39.777 114.191-79.554 195.813-85.236L133.421 354.1c-63.84-11.327-85.065-62.17-70.149-119.33h90.852l16.546-45.46H82.235c24.866-43.394 68.874-85.485 129.386-112.512-215.017 44.323-287.927 260.255-82.336 288.667l-10.342 28.412c7.229 11.365 52.688 11.365 68.19 0l10.34-28.412C429.43 337.053 514.228 104.073 303.926 72.991l7.301-20.06c77.486 5.683 119.833 45.46 133.767 85.237 6.727-34.094-2.026-119.33-128.586-130.696zm24.654 88.387C434.151 121.12 357.626 331.37 201.61 354.1z",
  stroke: "#000",
  strokeWidth: 4.945
});

var SvgEtfRoundTextOglasna = function SvgEtfRoundTextOglasna(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 409.873,
    width: 1885.503,
    viewBox: "0 0 1886 410",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("text", {
    y: 120.602,
    x: 1185.3,
    style: {
      lineHeight: 3.1
    },
    fontWeight: 400,
    fontSize: 13.333,
    fontFamily: "sans-serif",
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      lineHeight: 1.2,
      InkscapeFontSpecification: "'Open Sans'",
      textAlign: "center"
    },
    y: 120.602,
    x: 1185.3,
    fontSize: 74.667,
    fontFamily: "Open Sans",
    textAnchor: "middle"
  }, "\u0420\u0430\u0447\u0443\u043D\u0430\u0440\u0441\u043A\u0438 \u0446\u0435\u043D\u0442\u0430\u0440"), /*#__PURE__*/React.createElement("tspan", {
    dy: 0,
    style: {
      lineHeight: 1.2,
      InkscapeFontSpecification: "'Open Sans Bold'",
      textAlign: "center"
    },
    y: 228.571,
    x: 1185.3,
    fontWeight: 700,
    fontSize: 96,
    fontFamily: "Open Sans",
    textAnchor: "middle"
  }, "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u0442\u0435\u0445\u043D\u0438\u0447\u043A\u0438 \u0444\u0430\u043A\u0443\u043B\u0442\u0435\u0442"), /*#__PURE__*/React.createElement("tspan", {
    style: {
      lineHeight: 1.2,
      InkscapeFontSpecification: "'Open Sans'",
      textAlign: "center"
    },
    y: 325.402,
    x: 1185.3,
    fontSize: 74.667,
    fontFamily: "Open Sans",
    textAnchor: "middle"
  }, "\u0423\u043D\u0438\u0432\u0435\u0440\u0437\u0438\u0442\u0435\u0442 \u0443 \u0411\u0430\u045A\u043E\u0458 \u041B\u0443\u0446\u0438")), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEtfRoundTextOglasna, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/etf-round-text-oglasna.2b8718a7.svg";
export { ForwardRef as ReactComponent };